<template>
  <div id="base-video-player" class="video-player">
    <div class="video-player__thumb" :class="isIframeReady ? 'fade-out-hide' : 'fade-in-show'">
      <button
        v-if="!loading"
        type="button"
        class="video-player__thumb__play"
        @click="createVideoIframe()"
      >
        <VideoPlayIcon />
      </button>
      <div v-else class="video-player__thumb__loading">
        <Loading />
      </div>
      <img :src="$router.options.imagePath + thumb" class="video-player__thumb__image" />
    </div>
    <div ref="videoContainer" class="video-player__embed" />
  </div>
</template>
<script>
import VideoPlayIcon from '@/components/svg/VideoPlayIcon.vue';
import Loading from '@/components/ui/Loading.vue';
import { bus } from '../main';
export default {
  name: 'BaseVideoPlayer',
  components: {
    VideoPlayIcon,
    Loading
  },
  props: {
    youtubeLink: {
      type: String,
      required: true
    },
    thumb: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isIframeReady: false,
    videoContainer: null,
    loading: false
  }),
  computed: {
    createIframeUrl() {
      return `https://www.youtube.com/embed/${this.youtubeLink}?autoplay=1&modestbranding=1`;
    }
  },
  created() {
    bus.$on('radio-on', isRadioPlaying => {
      if (isRadioPlaying) this.killVideoIframe();
    });
  },
  methods: {
    createVideoIframe() {
      if (this.videoContainer) return;
      this.loading = true;
      this.videoContainer = this.$refs.videoContainer;
      const iframe = document.createElement('iframe');
      const setAttributes = (element, attrs) => {
        for (let key in attrs) {
          element.setAttribute(key, attrs[key]);
        }
      };
      const attrs = {
        id: 'youtube-iframe',
        src: this.createIframeUrl,
        width: '100%',
        height: '100%',
        frameBorder: '0',
        allow: 'autoplay',
        allowfullscreen: ''
      };
      setAttributes(iframe, attrs);
      iframe.addEventListener('load', () => {
        this.isIframeReady = true;
        this.loading = false;
      });
      this.videoContainer.appendChild(iframe);
      bus.$emit('radio-status', false);
      bus.$emit('destroy-mixcloud');
    },
    killVideoIframe() {
      if (!this.videoContainer) return;
      this.isIframeReady = false;
      // All listeners attached will be removes from the iframe element
      this.videoContainer.firstChild.removeEventListener('load', () => {}, true);
      this.videoContainer.firstChild.remove();
      this.videoContainer = null;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_base-video-player.scss';
</style>
